module.exports = __webpack_public_path__ + "static/media/cheque-azul.db6330d5.png";